<article>
  <h1>
    Which mass shootings are more newsworthy, and why?
  </h1>
  <p><a href="https://yuriko-schumacher.github.io/" target="_blank">By Yuriko Schumacher</a></p>
</article>

<style>
  article {
    text-align: center;
    margin: 5em auto;
  }

  a:link, a:visited {
    color: #eeeeee;
  }

  a:hover {
    color: rgb(255, 217, 0);
    transition: all 0.4s ease;
  }
</style>